import chooseNextProperId from 'helpers/chooseNextProperId'
import { getPeripheralDefaults } from 'helpers/accessControl/defaults'

export default function addPeripheral(state, action) {
  const { peripheralType, doorId } = action
  const { entities, entities: { doors } } = state
  const peripherals = entities[peripheralType]

  if (!peripherals) return state

  const id = chooseNextProperId(peripherals.allIds)
  const door = doors.byId[doorId]

  if (!door) return state

  const peripheral = Object.assign({}, getPeripheralDefaults(peripheralType), { id })

  return Object.assign({}, state, {
    entities: {
      ...state.entities,
      doors: {
        allIds: doors.allIds,
        byId: {
          ...doors.byId,
          [doorId]: {
            ...door,
            [peripheralType]: door[peripheralType].concat(id)
          }
        }
      },
      [peripheralType]: {
        byId: {
          ...peripherals.byId,
          [id]: peripheral
        },
        allIds: peripherals.allIds.concat(id)
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/reducers/addPeripheral.js